import React from 'react'
import Link from 'gatsby-link'

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
} from 'reactstrap'

import logo from './logo.png'

export default class Example extends React.Component {
  constructor(props) {
    super(props)

    this.toggle = this.toggle.bind(this)
    this.state = {
      isOpen: false,
    }
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.location !== this.props.location &&
      this.state.isOpen === true
    ) {
      this.hide()
    }
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }
  hide() {
    this.setState({
      isOpen: false,
    })
  }
  render() {
    return (
      <div>
        <Navbar
          className="fixed-top border-bottom"
          light
          color="white"
          expand="md"
        >
          <NavbarBrand className="d-flex align-items-center" href="/">
            <img
              style={{ height: '2rem' }}
              className="mr-2"
              src={logo}
              alt="Logo"
            />
            <div className="brand">DupliDocs</div>
          </NavbarBrand>

          {/* <NavbarToggler onClick={this.toggle} /> */}
          {/* <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="mr-auto" navbar>
              <NavItem>
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/pricing">
                  Pricing
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/blog">
                  Blog
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/about-us">
                  About Us
                </Link>
              </NavItem>
            </Nav>
            <hr className="d-md-none" />
            <Nav className="ml-auto" navbar>
              <NavItem>
                <Link className="nav-link" to="/get-started">
                  Sign Up
                </Link>
              </NavItem>
              <NavItem>
                <Link className="nav-link" to="/get-started">
                  Log In
                </Link>
              </NavItem>
            </Nav>
          </Collapse> */}
        </Navbar>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js